import script from "./settingDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./settingDropdown.vue?vue&type=script&setup=true&lang=js"

import "./settingDropdown.vue?vue&type=style&index=0&id=2d48277e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d48277e"]])

export default __exports__